import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'when_a_disciplinary_action_is_initiated_against_a_worker_is_tha'

export const dataPointDefinition = {
  retracedId: 'when_a_disciplinary_action_is_initiated_against_a_worker_is_tha',
  name: 'When a disciplinary action is initiated against a worker, is that worker always informed?',
  description:
    "The intent of this question is to understand if workers are always informed when there is some type of disciplinary measure or action taken against them. \r\r\n\r\r\nFor example, if as a result of a worker's consistent tardiness (lateness) to work, a written warning is included in their personnel file, but this action was not communicated to the worker, answer No.\r\r\n\r\r\nIf there is no example of disciplinary action, i.e. there has been no disciplinary action in the last months within this assessment period, but you have a policy/ procedure in place around informing workers of disciplinary action that has been initiated against them, answer Yes.\r\r\n",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'discp-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11560,
  sectionId: '2.2.4.4',
  impactArea: 'Discipline',
  impactAreaId: 'DISCIPLINE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
